var React = require('react');

function PhoneIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M340.3,275.1l-53.8-53.8c-10.7-10.7-28.4-10.3-39.5,0.7l-27.1,27.1c-1.7-0.9-3.5-1.9-5.3-3\n\t\t\t\tc-17.1-9.5-40.5-22.5-65.1-47.1c-24.7-24.7-37.7-48.1-47.2-65.3c-1-1.8-2-3.6-2.9-5.2l18.2-18.1l8.9-8.9\n\t\t\t\tc11.1-11.1,11.4-28.8,0.7-39.5L73.4,8.2C62.7-2.5,45-2.2,33.9,8.9L18.7,24.2l0.4,0.4c-5.1,6.5-9.3,14-12.5,22\n\t\t\t\tc-2.9,7.7-4.7,15-5.6,22.3C-6,127.8,20.9,181.6,93.9,254.5c100.9,100.9,182.2,93.2,185.7,92.9c7.6-0.9,15-2.7,22.4-5.6\n\t\t\t\tc8-3.1,15.5-7.4,21.9-12.4l0.3,0.3l15.3-15C350.6,303.5,351,285.8,340.3,275.1z"})))));
}

PhoneIcon.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 348.1 348.1","style":{"enableBackground":"new 0 0 348.1 348.1"},"xmlSpace":"preserve"};

module.exports = PhoneIcon;

PhoneIcon.default = PhoneIcon;
